"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldRenderEmptyState = shouldRenderEmptyState;
exports.makeInsertEmbedChangeHandler = exports.makeInsertQuestionAndAnswerChangeHandler = exports.makeInsertVideoChangeHandler = exports.makeInsertImageChangeHandler = exports.deleteImageFromEditorState = void 0;

var _constants = require("composer-lib/lib/constants");

var _draftJs = require("draft-js");

// Delete image at selection anchor, and set new selection to end of block before the former image
var deleteImageFromEditorState = function deleteImageFromEditorState(editorState) {
  var currentContent = editorState.getCurrentContent();
  var currentKey = editorState.getSelection().getAnchorKey();
  var key = currentContent.getKeyBefore(currentKey);
  var contentState = currentContent.set('blockMap', currentContent.getBlockMap().delete(key));
  var blockBeforeImageKey = currentContent.getKeyBefore(key);
  var selection;

  if (!blockBeforeImageKey) {
    selection = _draftJs.SelectionState.createEmpty(currentKey);
  } else {
    var blockBeforeImageLength = currentContent.getBlockForKey(blockBeforeImageKey).getLength();
    selection = _draftJs.SelectionState.createEmpty(blockBeforeImageKey).set('anchorOffset', blockBeforeImageLength).set('focusOffset', blockBeforeImageLength);
  }

  return _draftJs.EditorState.forceSelection(_draftJs.EditorState.push(editorState, contentState), selection);
};

exports.deleteImageFromEditorState = deleteImageFromEditorState;

var makeInsertImageChangeHandler = function makeInsertImageChangeHandler(insertImage) {
  return function (imageData) {
    return insertImage(imageData);
  };
};

exports.makeInsertImageChangeHandler = makeInsertImageChangeHandler;

var makeInsertVideoChangeHandler = function makeInsertVideoChangeHandler(insertVideo) {
  return function (videoData) {
    return insertVideo(videoData);
  };
};

exports.makeInsertVideoChangeHandler = makeInsertVideoChangeHandler;

var makeInsertQuestionAndAnswerChangeHandler = function makeInsertQuestionAndAnswerChangeHandler(insertQuestionAndAnswer) {
  return function (questionAndAnswerData) {
    return insertQuestionAndAnswer(questionAndAnswerData);
  };
};

exports.makeInsertQuestionAndAnswerChangeHandler = makeInsertQuestionAndAnswerChangeHandler;

function shouldRenderEmptyState(_ref) {
  var saveState = _ref.saveState,
      composition = _ref.composition;
  var content = saveState.content,
      readOnly = saveState.readOnly,
      summary = saveState.summary,
      title = saveState.title;
  var showReadOnlyMode = composition.isReadOnly();
  var bodyHasContent = content.getCurrentContent().hasText();
  var titleHasContent = title.length > 0;
  var summaryHasContent = summary && summary.length > 0;
  return (readOnly || showReadOnlyMode) && !bodyHasContent && !titleHasContent && !summaryHasContent && composition.get('type') !== _constants.CompositionTypes.KNOWLEDGE_ARTICLE;
}

var makeInsertEmbedChangeHandler = function makeInsertEmbedChangeHandler(insertEmbed) {
  return function (embedData) {
    return insertEmbed(embedData);
  };
};

exports.makeInsertEmbedChangeHandler = makeInsertEmbedChangeHandler;